// extracted by mini-css-extract-plugin
export var externalLink = "_dd-0";
export var internalLinkLabel = "_dd-1";